import { Node, mergeAttributes } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    youtube: {
      setYoutubeVideo: (options: { src: string }) => ReturnType;
    };
  }
}

export const YouTube = Node.create({
  name: "youtube",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'iframe[src*="youtube.com"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { src } = HTMLAttributes;
    return [
      "div",
      { class: "aspect-video w-full rounded-lg overflow-hidden" },
      [
        "iframe",
        mergeAttributes(HTMLAttributes, {
          src,
          frameborder: "0",
          allowfullscreen: "true",
          class: "w-full h-full",
        }),
      ],
    ];
  },

  addCommands() {
    return {
      setYoutubeVideo:
        (options) =>
        ({ commands }) => {
          const url = new URL(options.src);
          const videoId = url.searchParams.get("v");
          if (!videoId) return false;

          const embedUrl = `https://www.youtube.com/embed/${videoId}`;
          return commands.insertContent({
            type: this.name,
            attrs: { src: embedUrl },
          });
        },
    };
  },
});
